import React from 'react';
const ArrowSvg = ({ color = 'white', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="11"
      viewBox="0 0 7 11"
      fill="none"
      className={className}
      {...props}
      onClick={onClick}
    >
      <path
        d="M1.88253 0.525046C1.88253 0.525047 1.88253 0.525047 1.88253 0.525048L6.42713 5.06948C6.5347 5.17704 6.60556 5.33567 6.60556 5.49826C6.60556 5.66098 6.53458 5.8196 6.42714 5.92704L1.88261 10.4716C1.75929 10.5949 1.61311 10.65 1.45383 10.65C1.29445 10.65 1.14838 10.5949 1.02508 10.4716C0.791624 10.2383 0.791668 9.84747 1.02505 9.61409L5.14083 5.49831L1.02508 1.38256C1.02507 1.38255 1.02506 1.38254 1.02505 1.38253C0.791634 1.14922 0.791678 0.758452 1.02502 0.525078L1.88253 0.525046ZM1.88253 0.525046C1.64916 0.291678 1.25837 0.291624 1.02505 0.525048L1.88253 0.525046Z"
        fill={color}
        stroke={color}
        strokeWidth="0.3"
      />
    </svg>
  );
};

export default ArrowSvg;
